export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "es",
    "resource": {
      "securityMessage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tu información está segura y protegida."])}
    }
  })
}
